<template>
    <v-card class="mx-auto card-responsive card-spacing card-center">
      <ValidationObserver ref="observer" v-slot="{ validate }">
        <v-card-text>
          <div class="form-group mt-3 text-center">
            <label class="nps-label">Em uma escala de 0 a 10, o quanto você recomendaria este treinamento a um colega?</label>
            <div class="nps-scale">
              <v-btn
                v-for="index in 11"
                :key="index"
                :class="['nps-button', {'nps-button-selected': form.nps === (index - 1)}]"
                @click="setNps(index - 1)"
                depressed
              >
                <v-img
                  :src="getIconPath(index - 1)"
                  contain
                  class="nps-icon"
                ></v-img>
                <div class="nps-number">{{ index - 1 }}</div>
              </v-btn>
            </div>
          </div>
          <div class="form-actions mt-3">
            <button type="button" @click="anteriorEtapa" class="btn btn-secondary">Anterior</button>
            <button type="button" @click="proximaEtapa(validate)" class="btn btn-primary btn-proximo">Enviar</button>
          </div>
        </v-card-text>
      </ValidationObserver>
    </v-card>
  </template>
  
  <script>
  import { ValidationObserver } from 'vee-validate';
  
  export default {
    name: 'Nps',
    components: {
      ValidationObserver
    },
    data() {
      return {
        form: {
          nps: null,
          escala: ''
        }
      };
    },
    methods: {
      setNps(value) {
        this.form.nps = value;
        this.form.escala = this.getEscala(value);
        this.$emit('update:nps', value);
        this.$emit('update:escala', this.form.escala);
      },
      anteriorEtapa() {
        this.$emit('anterior-etapa');
      },
      async proximaEtapa(validate) {
        const isValid = await validate();
        if (isValid && this.form.nps !== null) {
          this.$emit('proxima-etapa');
        } else {
          this.$toast.error('Por favor, selecione um número entre 0 e 10.', 'Erro:', {
            position: 'topRight',
          });
        }
      },
      getIconPath(number) {
        return require(`@/assets/icones/Nps/${number}.png`);
      },
      getButtonColor(number) {
        const colors = [
          '#FF0000', '#FF3300', '#FF6600', '#FF9900', '#FFCC00',
          '#FFFF00', '#CCFF00', '#99FF00', '#66FF00', '#33FF00', '#00FF00'
        ];
        return colors[number];
      },
      getEscala(value) {
        if (value >= 9) return 'Promotora';
        if (value >= 7) return 'Neutra';
        return 'Detratora';
      }
    }
  }
  </script>
  
<style scoped>
    .v-btn.v-btn {
        height: 70px !important;
    }

    .v-responsive {
            position: relative;
            overflow: hidden;
            flex: 2 0 auto;
            max-width: 65%;
            display: flex;
        }
  
    .nps-label {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
    }
  
    .nps-scale {
        display: flex;
        justify-content: center;
        gap: 5px;
        padding: 55px 0 90px;
        flex-wrap: wrap;
    }
  
  .nps-button {
    flex: 1 1 8%;
    max-width: 70px;
    height: 70px;
    line-height: 60px;
    text-align: center;
    font-size: 14px;
    margin: 0;
    cursor: pointer;
    font-weight: bold;
    padding: 0;
    position: relative;
  }
  
  .nps-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  .nps-number {
    position: absolute;
    top: -3px;
    right: 19px;
    width: 24px;
    height: 25px;
    border-radius: 50%;
    background-color: white;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 19px;
    font-weight: bold;
    box-shadow: inset 0px -1px 0 rgb(0 0 0 / 63%);
  }
  
  .nps-button-selected {
    border: 2px solid #ff0000;
    color: white !important;
    background-color: #0fafd7 !important;
  }
  
  /* Ajustes responsivos */
  @media (max-width: 768px) {
    .v-responsive {
        position: relative;
        overflow: hidden;
        flex: 2 0 auto;
        max-width: 65%;
        display: flex;
    }

    .nps-button {
        flex: 1 1 10%;
        max-width: 60px;
        height: 60px;
    }
  
    .nps-number {
        width: 25px;
        height: 25px;
        font-size: 20px;
        top: -3px;
        right: 15px;
    }

    .nps-scale {
        display: flex;
        justify-content: center;
        gap: 15px;
        padding: 55px 0 90px;
        flex-wrap: wrap;
    }

  }
  
  @media (max-width: 480px) {
    .nps-button {
        flex: 1 1 12%;
        max-width: 50px;
        height: 50px;
    }
  
    /* .nps-number {
        width: 16px;
        height: 16px;
        font-size: 12px;
    } */
  
    .nps-label {
        font-size: 16px;
    }
  }
</style>
  